import './modal-error.styles.scss';
import IconError from '../../assets/icons/error.svg';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { selectErrorMessage, selectModalFromErrors } from '../../redux/modal/modal.reselect';

const ModalError = ({ 
    formValidationError,
    formErrors,
    formResponseError,
    errorMessage
 }) => (
    <div className="modal-error">
        <div className="modal-error__header">
            <img src={IconError} className="modal-error__header__icon" alt="error" />
            { 
                formValidationError ? 
                    "Review the following fields" :
                    formResponseError && "An error has occurred"
            }
        </div>
        <div className="modal-error__body">
            {
                console.log("global error")
            }
            {
                formValidationError ?
                    <ul className="modal-error__body__container">
                        {
                            Object.keys(formErrors).map(fieldError => (
                                formErrors[fieldError].map((fieldGroupError,index) => (
                                    Object.keys(fieldGroupError).map((fieldItemError) => (
                                        <li 
                                        key= {fieldItemError} 
                                        className="modal-error__body__item">
                                            {formErrors[fieldError][index][fieldItemError].message}
                                    </li>
                                    ))
                                ))     
                            )) 
                        }
                    </ul> :
                    formResponseError ? 
                        errorMessage :
                        null
            }
        </div>
    </div>
)

const mapStateToProps = createStructuredSelector({
    formErrors: selectModalFromErrors,
    errorMessage: selectErrorMessage
})

export default connect(mapStateToProps)(ModalError);
